import * as React from 'react';

const DownloadIcon = ({ color = '#FD7548' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={18} height={18} className='DownloadIcon'>
    <g fill='none' fillRule='evenodd'>
      <path fill={color} d='m9 14.4.4.4L17 7l-.4-.5-7.2 7.2V0h-.8v13.7L1.4 6.5 1 7l7.6 7.8M0 16.4V18h18v-1.6' />
      <path d='M-4-4h26v26H-4z' />
    </g>
  </svg>
);
export default DownloadIcon;
